import React from 'react';
import './ProjectDetail.css';
import CustomDropdown from './CustomDropdown';
import CompensationTable from './CompensationTable';
import ResultTable from './ResultTable';
import Footer from '../pages/Footer';

function ProjectDetail({ 
  language, 
  selectedTaluk, 
  selectedHobli, 
  selectedVillage,
  onTalukChange,
  onHobliChange,
  onVillageChange,
  onSubmit,
  translations,
  taluks,
  hoblis,
  villages,
  canSubmit,
  villageData,
  isSubmitted,
  formatCurrency
}) {
  const t = translations[language];
  const isKannada = language === 'kannada';

  return (
    <div>
      <section className="hero-section">
        <div className="hero-container">
          <div className="hero-village-selection-wrapper">
            <div className="hero-village-selection">
              <h2 className="hero-panel-title">{t.villageSelectionTitle}</h2>
              <div className="hero-dropdown-group">
                <div className="hero-dropdown-wrapper">
                  <label>{t.taluk}</label>
                  <CustomDropdown
                    options={taluks}
                    value={selectedTaluk}
                    onChange={onTalukChange}
                    placeholder={isKannada ? 'ತಾಲ್ಲೂಕನ್ನು ಆಯ್ಕೆ ಮಾಡಿ' : 'Select Taluk'}
                  />
                </div>
                <div className="hero-dropdown-wrapper">
                  <label>{t.hobli}</label>
                  <CustomDropdown
                    options={hoblis}
                    value={selectedHobli}
                    onChange={onHobliChange}
                    placeholder={isKannada ? 'ಹೋಬಳಿಯನ್ನು ಆಯ್ಕೆ ಮಾಡಿ' : 'Select Hobli'}
                  />
                </div>
                <div className="hero-dropdown-wrapper">
                  <label>{t.grama}</label>
                  <CustomDropdown
                    options={villages}
                    value={selectedVillage}
                    onChange={onVillageChange}
                    placeholder={isKannada ? 'ಗ್ರಾಮವನ್ನು ಆಯ್ಕೆ ಮಾಡಿ' : 'Select Village'}
                  />
                </div>
              </div>
              <button 
                className="hero-submit-button"
                onClick={onSubmit}
                disabled={!canSubmit}
              >
                {isKannada ? 'ಸಲ್ಲಿಸಿ' : 'Submit'}
              </button>
            </div>
          </div>
          <div className="hero-table-wrapper">
            {isSubmitted && villageData ? (
              <ResultTable 
                language={language} 
                villageData={villageData}
                formatCurrency={formatCurrency}
              />
            ) : (
              <CompensationTable language={language} />
            )}
          </div>
        </div>
      </section>
      <Footer language={language} />
    </div>
  );
}

export default ProjectDetail;
